// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Spinner-cls1___17b58dd923442a038ac{/*!*/}.Spinner-cls2__c8699c07718105b4865c{border:4px solid #d9d9d9;border-left-color:#91919e;border-radius:50%;animation:Spinner-spin___0d7e8c5e17dfa8880d2 1s infinite linear;display:inline-block}.Spinner-cls2__c8699c07718105b4865c.Spinner-blue___539b5d140233ee91e35{border:8px solid #cddaef;border-left-color:#386ac1}@keyframes Spinner-spin___0d7e8c5e17dfa8880d2{from{transform:rotate(0)}to{transform:rotate(360deg)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Spinner-cls1___17b58dd923442a038ac",
	"cls2": "Spinner-cls2__c8699c07718105b4865c Spinner-cls1___17b58dd923442a038ac",
	"spin": "Spinner-spin___0d7e8c5e17dfa8880d2",
	"blue": "Spinner-blue___539b5d140233ee91e35"
};
export default ___CSS_LOADER_EXPORT___;
